function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icons");

var SvgIconFile = function SvgIconFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("polygon", {
    points: "30.76 27.5 43.45 27.5 49.24 32.97 49.24 52.5 30.76 52.5 30.76 27.5",
    style: {
      fillRule: "evenodd"
    }
  }), React.createElement("rect", {
    x: 33.96,
    y: 32.47,
    width: 5.8,
    height: 1,
    style: {
      fill: "#666"
    }
  }), React.createElement("rect", {
    x: 33.96,
    y: 36,
    width: 12.3,
    height: 1,
    style: {
      fill: "#666"
    }
  }), React.createElement("rect", {
    x: 33.96,
    y: 40,
    width: 12.3,
    height: 1,
    style: {
      fill: "#666"
    }
  }), React.createElement("rect", {
    x: 33.96,
    y: 44,
    width: 12.3,
    height: 1,
    style: {
      fill: "#666"
    }
  }), React.createElement("rect", {
    x: 33.96,
    y: 48,
    width: 12.3,
    height: 1,
    style: {
      fill: "#666"
    }
  }), React.createElement("polyline", {
    points: "49.24 32.94 43.45 32.94 43.45 27.5",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-file.9cd5e2fc.svg";
export { ForwardRef as ReactComponent };